import React from 'react'

const FinancialAid = () => {
  return (
    <div>
    <h1>is there financial aid?</h1>
    <hr />
    <p>We believe that money should not be a barrier to your success if you have completed levelZero and have been selected for levelOne. To enable you to secure your seat in levelOne and change the economic scenario of your family by getting a job by June 2023. we have reserved seats for financial aid. There is no exact seat limitation for financial aid applicants, whereas one needs to perform well through portfolio and application to qualify for the aid.</p>

    <ol>
        <li>who can apply for financial aid?
            <ul>
                <li>people who can and are ready to get placed in June 2023 and</li>
                <li>people whose family income is less than Rs. 50,000 a month.</li>
                <p>Hence, you can apply if you are going to graduate by June 2023 or anyone looking to shift their job and is eligible to join in June 2023 and the monthly income of your family is less than Rs.50,000. Our partner roc8.careers and we are there to help you to land a job or you can take it by yourself (no barriers of any kind to your success).</p>
            </ul>
        </li>
        <li>why such criteria to apply for aid?
            <ul>
                <li>It is for people who have less income in their families and can utilize this program more by starting earning as soon as possible. That one seat can enable that person to increase the monthly income of their family by 40-50k. That’s a huge value add to a family who’s not able to pay 30k + 18% GST + a convenience fee may be charged by the payment gateway you choose to pay with as fees.</li>
                <li>For the students who are in the 1st-3rd year and have time to graduate, we apologise that the financial aid is not for you for now. We are really sorry. We hope that your family income improves by the time you enter your 4th year and if not, we promise to be there and provide you with the financial aid needed for this course, at that time.</li>
                <li>The overall intent is to help, we apologize if our words or structure hurt any of your sentiments.</li>
                <p>The hope behind this whole camp is to help the community at large. We understand that you wish to join first, but let’s give the chance to people who can join a job immediately and change their and their families’ lives.</p>
            </ul>
        </li>
    </ol>
</div>
  )
}

export default FinancialAid